import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const RISK_COLOR = '#EF4444';

export const RiskNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={RISK_COLOR} icon={'\u26A0'} selected={selected} />;
};

export default RiskNode;
